import DisclaimerModal from "./ui/DisclaimerModal";
import { useState } from "react";

const Footer = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <footer
      className='footer bg-light p-2 '
      style={{ borderTop: "0.1rem solid #e5e5e5" }}
    >
      <div className='container-fluid'>
        <div className='d-flex flex-column flex-md-row justify-content-center align-items-center'>
          <div className='fs-6'>
            <a
              href='https://www.linkedin.com/company/spectra-plasmonics/'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-linkedin mx-1 text-muted'></i>
            </a>
            <a
              href='https://www.instagram.com/spectra_plasmonics?igsh=NGplZ2JnM2cyeXEy'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-instagram mx-1 text-muted'></i>
            </a>
            <a href='https://x.com/@SPlasmonics' target='_blank' rel='noreferrer'>
              <i className='bi bi-twitter-x mx-1 text-muted'></i>
            </a>
            <a href='mailto:info@spectraplasmonics.com' target='_blank' rel='noreferrer'>
              <i className='bi bi-envelope mx-1 text-muted'></i>
            </a>
            <a href='https://www.spectraplasmonics.com/' target='_blank' rel='noreferrer'>
              <i className='bi bi-globe2 mx-1 text-muted'></i>
            </a>
          </div>

          <div className='d-flex flex-column justify-content-center align-items-center mt-2 mt-md-0 ms-md-auto text-center text-md-end'>
            <div className='small text-muted '>
              Copyright © - 2025 Spectra Plasmonics Inc.
            </div>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className='small' onClick={() => setShowDisclaimer(true)}>
              Disclaimer
            </a>
          </div>
        </div>
      </div>
      <DisclaimerModal
        show={showDisclaimer}
        handleClose={() => setShowDisclaimer(false)}
      />
    </footer>
  );
};
export default Footer;
